import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  getAgentInfo,
  selectAgentInfo,
} from "../../../state/ducks/member/index";
import EminevimLoading from "../shared/EminevimLoading";

class AgentInfo extends Component {
  state = {
    isLoading: true,
    shouldAnimateCards: false,
  };

  componentDidMount() {
    this.props
      .getAgentInfo()
      .finally(() => {
        this.setState({ isLoading: false, shouldAnimateCards: true });
        window.setTimeout(() => this.setState({ shouldAnimateCards: false }), 1200);
      });
  }

  renderField = (label, value) => (
    <div className="t-memberInfo-field">
      <span className="t-memberInfo-fieldLabel">{label}</span>
      <span className="t-memberInfo-fieldValue">{value || "-"}</span>
    </div>
  );

  renderAgentLoading = () => (
    <EminevimLoading subtext="Temsilci bilgileriniz hazırlanıyor, lütfen bekleyiniz." />
  );

  renderCard = (options) => {
    const {
      index,
      themeClass,
      iconClass,
      title,
      subtitle,
      actions,
      children,
    } = options;
    const { shouldAnimateCards } = this.state;

    return (
      <article
        className={`t-memberInfo-card${shouldAnimateCards ? " t-memberInfo-card--enter" : ""} ${themeClass}`}
        style={shouldAnimateCards ? { animationDelay: `${index * 80}ms` } : undefined}
      >
        <div className="t-memberInfo-cardHeader">
          <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
            <i className={iconClass} aria-hidden="true" />
          </div>

          <div className="t-memberInfo-cardHeaderContent">
            <h2 className="t-memberInfo-cardTitle">{title}</h2>
            {subtitle && (
              <div className="t-memberInfo-cardBadges">
                <span className="t-memberDetail-headerBadge">{subtitle}</span>
              </div>
            )}
          </div>

          {actions && <div className="t-memberInfo-cardActions">{actions}</div>}
        </div>

        {children}
      </article>
    );
  };

  renderOperationsTable = (items) => (
    <div className="t-agentInfo-tableWrap">
      <table className="t-agentInfo-table">
        <thead>
          <tr>
            <th scope="col">Ad Soyad</th>
            <th scope="col">E-Posta</th>
            <th scope="col">Telefon</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={`${item.telefon}_${index}`}>
              <td>{item.adSoyad || "-"}</td>
              <td>{item.eposta || "-"}</td>
              <td>{item.telefon || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  render() {
    const { agent } = this.props;
    const { isLoading } = this.state;
    const hasOperations =
      agent?.musteriHizmetleriYetkilileri &&
      agent.musteriHizmetleriYetkilileri.length > 0;

    return (
      <div className="t-agentInfo-page" style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Temsilci Bilgileri</h1>
              <p className="t-memberInfo-pageSubtitle">
                Temsilciniz, müşteri operasyon yetkilileri ve şube iletişim bilgilerinizi görüntüleyin.
              </p>
            </div>

            {isLoading ? (
              this.renderAgentLoading()
            ) : (
              <div className="t-memberInfo-list">
                {this.renderCard({
                  index: 0,
                  themeClass: "t-memberDetail-header--blue",
                  iconClass: "t-icon-user-tie",
                  title: agent?.temsilci || "Temsilci Bilgileri",
                  subtitle: "Müşteri Temsilcisi",
                  actions: (
                    <Link
                      to="/Home/AskToAgent"
                      className="t-memberInfo-btn t-memberInfo-btn--primary"
                    >
                      <span>Temsilcime Sor</span>
                      <i className="t-icon-arrow-right2" aria-hidden="true" />
                    </Link>
                  ),
                  children: (
                    <div className="t-memberInfo-grid">
                      {this.renderField("Adı Soyadı", agent?.temsilci)}
                      {agent?.iletisimList &&
                        agent.iletisimList.map((item) => (
                          <React.Fragment key={item.tip}>
                            {this.renderField(item.tip, item.bilgi)}
                          </React.Fragment>
                        ))}
                    </div>
                  ),
                })}

                {hasOperations &&
                  this.renderCard({
                    index: 1,
                    themeClass: "t-memberDetail-header--green",
                    iconClass: "t-icon-users",
                    title: "Müşteri Operasyon Yetkilileri",
                    children: this.renderOperationsTable(agent.musteriHizmetleriYetkilileri),
                  })}

                {this.renderCard({
                  index: hasOperations ? 2 : 1,
                  themeClass: "t-memberDetail-header--orange",
                  iconClass: "t-icon-phone2",
                  title: "Şube İletişim Bilgileri",
                  subtitle: agent?.sube?.subeAdi,
                  children: (
                    <div className="t-memberInfo-grid">
                      {this.renderField("Şube Telefonu", agent?.sube?.telefon1)}
                      {this.renderField("Şube Fax", agent?.sube?.fax1)}
                      {this.renderField("Şube Mail", agent?.sube?.email1)}
                      <div className="t-accountInfo-fieldFull">
                        {this.renderField("Şube Adresi", agent?.sube?.adres)}
                      </div>
                      {this.renderField("Şube İlçesi", agent?.sube?.ilce)}
                      {this.renderField("Şube Şehri", agent?.sube?.sehir)}
                      {this.renderField("Şube Ülkesi", agent?.sube?.ulke)}
                    </div>
                  ),
                })}
              </div>
            )}
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  agent: selectAgentInfo(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAgentInfo: () => dispatch(getAgentInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentInfo);
